import { RoleName, UserStatus } from "@shared/models";

export const userStatusName = {
  [UserStatus.invited]: "Invited",
  [UserStatus.active]: "Active",
  [UserStatus.deleted]: "Inactive",
};

export const CompanyDetailsFields = {
  "Hubspot ID": "hubspot_company_id",
  "Chargebee ID": "chargebee_customer_id",
  "Total Numbers of Active Users": "activeUsers",
  "Flik ID": "claritas_id",
  "Company creation date": "creationDate",
};

export const CompanyDetailsTabNames = {
  Details: "Details",
  Files: "Files",
  Presets: "Presets",
  DeployLists: "Deploy Lists",
  Users: "Users",
  DataDelivery: "Data Delivery",
  NicheFiles: "Stacked Niche",
  Features: "Features",
  Integrations: "Integrations",
};

export const EditableUserRoles = [
  {
    label: "Admin",
    value: RoleName.admin,
    onlyForAdmin: true,
  },
  {
    label: "User",
    value: RoleName.user,
  },
  {
    label: "PPL dispute admin",
    value: RoleName.ppl_dispute_admin,
    onlyForAdmin: true,
  },
  {
    label: "PPL marketing team",
    value: RoleName.ppl_marketing_team,
  },
  {
    label: "Super Admin",
    value: RoleName.super_admin,
    readOnly: true,
  },
];
